import { type Availability, type AvailabilityRaw } from '../types/availability';

export const getAvailabilities = (rawAvailabilities: AvailabilityRaw[]): Availability[] => {
    return rawAvailabilities.map(availability => {
        return {
            ...availability,
            startDate: new Date(availability.startDate),
        };
    });
};

export const getAvailabilitiesByCapacity = (
    availabilities: Availability[],
    capacity: number,
): Availability[] => availabilities.filter(availability => availability.freeCapacity >= capacity);

export const getAvailabilitiesDateRange = (availabilities: Availability[]): Date[] =>
    availabilities.map(availability => availability.startDate);
